<template lang="pug">
.custom-categories-filter
  .text-small {{ title }}

  .d-flex.mt-2
    button.btn.btn-sm.flex-fill.mr-2.px-3(
      v-if='showTotalButton'
      :class='(!selectedTabIndex ? `btn-secondary`:`btn-outline-secondary`)'
      @click='selectedTabIndex = ``'
    )
      | ทั้งหมด
    button.btn.btn-sm.flex-fill.mr-2.px-3(
      v-for='(item, index) in items'
      v-html='item'
      :key='index'
      :class='(index == selectedTabIndex ? `btn-secondary`:`btn-outline-secondary`)'
      @click='selectedTabIndex = index'
    )
</template>

<script>
export default {
  props: {
    title: {
      default: 'lorem ipsum',
    },
    items: {
      default: [
        'item 1',
        'item 2',
      ],
    },
    // selected index
    value: {
      default: undefined,
    },
    showTotalButton: {
      default: true,
    },
  },
  watch: {
    selectedTabIndex: {
      handler(newVal) {
        this.$emit('input', newVal);
      },
      deep: true,
    },
    value(newVal) {
      this.selectedTabIndex = newVal;
    },
  },
  data: () => ({
    selectedTabIndex: undefined,
  }),
  mounted() {
    this.selectedTabIndex = this.value;
  },
};
</script>

<style lang="scss">
// .custom-categories-filter {}
</style>
